<template>
  <div class="text-bubble-input">
    <div class="input-container" :style="{top: coordinates.y + 'px', left: coordinates.x + 'px'}">
<!--      <vi-input v-model="message" ref="input" :autofocus="true"/>-->
      <input
        ref="input"
        v-model="message"
        @input="onInput"
        type="text"
        :maxlength="30"
        @click.stop="stopPropagation"
        @keydown.enter="sendMessage"
      />
      <div class="action" @click="sendMessage">
        <img src="../../assets/icon_send_message_white.svg" />
      </div>
      <div class="action" @click="closeMessage">
        <img src="../../assets/icon_clear.svg" />
      </div>
    </div>
  </div>
</template>

<script>
  import ViInput from "../ui/ViInput";
  export default {
    name: 'TextBubbleInput',
    components: {ViInput},
    props: {
      coordinates: {
        type: Object
      },
      localDataTrack: {
        type: Object
      }
    },
    data: () => ({
      message: null
    }),

    methods: {
      closeMessage() {
        this.localDataTrack.send(`A,T,CANCEL`);
        this.$emit('close')
      },
      sendMessage() {
        if(this.message) {
          this.localDataTrack.send(`A,T,S,${this.message}`);
          this.$emit('close')
        }
      },
      stopPropagation() {

      },
      onInput(message) {
        if(message.length > 30) {
          this.message = message.slice(0, 30)
        }
      }
    },

    mounted() {
      setTimeout(() => {
        this.$refs.input.focus()
      }, 50)
    }

  }
</script>

<style lang="scss">
@import "TextBubbleInput";
</style>
